export type OptionTypes =
    | Array<number>
    | Array<string | number>
    | Array<string>
    | number
    | string;

export enum SortOptions {
    Updated = 'updated',
    Created = 'created',
    Name = 'name',
}

export type BulkRequestOptions = {
    ids: string[];
    'sort-by'?: `${'' | '-'}${typeof SortOptions[keyof typeof SortOptions]}`;
};

export type PageRequestOptions = {
    limit?: number;
    offset?: number;
    'sort-by'?: `${'' | '-'}${typeof SortOptions[keyof typeof SortOptions]}`;
};

export type ExtendRequestOptions<T extends string[]> = {
    extend?: T;
};

/* eslint-disable-next-line no-use-before-define */
export type JSONValue = string | number | boolean | JSONObject | JSONArray;
export interface JSONObject {
    [x: string]: JSONValue;
}

export type JSONArray = Array<JSONValue>;
